import { Coating } from "@rhinov/savane-js";
import { WorktopController } from "./WortopController";

interface EventMapping {
    id: string;
    event: string;
    handler: (event: any) => void;
    param: string | null
}

export class  WorktopWidget {
    worktopController: WorktopController;
    generateWorktops = () => {
        this.worktopController.generateWorktops();
    }

    removeAllCredences = () => {
        this.worktopController.removeAllCredences();
        this.updateWorktopWidget();
    }

    setWorktopMode = () => {
        this.worktopController.setWorktopMode();
    }

    removeAllWorktop = () => {
        this.worktopController.removeAllWorktop();
        this.updateWorktopWidget();
    }

    toogleLeg = () => {
        this.worktopController.toogleLeg();
        this.updateWorktopWidget();
    }

    toogleCredence = () => {
        this.worktopController.toogleCredence();
        this.updateWorktopWidget();
    }

    openCoating = (event: MouseEvent) => {
        this.worktopController.openCoating((event.currentTarget as HTMLElement & {param?: string}).param!);
        this.updateWorktopWidget();
    }
    
    applyOffset = (event: MouseEvent) => {
        let [x, y] = (event.currentTarget as HTMLElement & {param?: string}).param!.split(",");
        var numx = Number(x);
        var numy = Number(y);
        this.worktopController.applyOffset(numx, numy);
    }
    
    leaveUpdateCoating = () => {
        this.worktopController.closeConfig();
        this.updateWorktopWidget();
    }

    getWorktopHeight = (event: Event) => {
        this.worktopController.worktop!.maxHeightCm = ((event.currentTarget as HTMLInputElement).value === "" ? 0 : Number((event.currentTarget as HTMLInputElement).value));
        this.worktopController.regenerateHull();
    }

    getCredenceHeight = (event: Event) => {
        this.worktopController.getsetCredenceHeight((event.currentTarget as HTMLInputElement).value === "" ? 0 : Number((event.currentTarget as HTMLInputElement).value));
        this.worktopController.regenerateHull();
    }

    updateCoating = (event: MouseEvent) => {
        this.worktopController.openConfig((event.currentTarget as HTMLElement & {coating?: Coating}).coating);
        this.worktopController.updateCoating(this.worktopController.worktopToConfigure,1);
        this.updateWorktopWidget();
    }

    /*
    A table containing id, event, function and parameter of function for each common HTML buttons that could be created  
    */
    eventMappings: EventMapping[] = [
        {id: 'LeaveUpdateCoating', event: 'click', handler: this.leaveUpdateCoating, param: null},
        {id: 'GenerateWorktop', event: 'mousedown', handler: this.generateWorktops,  param: null},
        {id: 'LeaveWorktop', event: 'mousedown', handler: this.setWorktopMode, param: null},
        {id: 'RemoveAllWorktop', event: 'mousedown', handler: this.removeAllWorktop, param: null},
        {id: 'RemoveAllCredences', event: 'mousedown', handler: this.removeAllCredences, param: null},
        {id: 'ToogleLegBut', event: 'click', handler: this.toogleLeg, param: null},
        {id: 'ToogleCredenceBut', event: 'click', handler: this.toogleCredence, param: null},
        {id: 'OpenCoating', event: 'click', handler: this.openCoating, param: 'coatings'},
        {id: 'OpenCoatingCredence', event: 'click', handler: this.openCoating, param: 'credence'},
        {id: 'OffsetLeft', event: 'click', handler: this.applyOffset, param: "-1, 0"},
        {id: 'OffsetRight', event: 'click', handler: this.applyOffset, param: "1, 0"},
        {id: 'OffsetUp', event: 'click', handler: this.applyOffset, param: "0, -1"},
        {id: 'OffsetDown', event: 'click', handler: this.applyOffset, param: "0, 1"},
    ];

    constructor(parent: HTMLElement) {
        this.worktopController = new WorktopController(() => {
            this.updateWorktopWidget();
        });
        parent.innerHTML = this.html();
        this.updateWorktopWidget();
    }

    updateWorktopWidget() {
        this.destroyEvents();
        this.updateWorktopPanel();
        this.bindEvents();
    }

    /*
    Set all the button listener and set a Timeout in order to wait for element creation.
    */
    bindEvents() {
        setTimeout(() => {
            //Set common button listener
            this.eventMappings.forEach(({id, event, handler, param}) => {
                let element = document.getElementById(id) as HTMLElement & {param?: string};
                if (!element) return;
                element.param = param ?? undefined;                
                element.addEventListener(event, handler);
            });

            //Set the two input box present on the interface.
            const worktopheight = document.getElementById("WorktopHeight") as HTMLInputElement;
            if (worktopheight) {
                worktopheight.value = "" + this.worktopController.worktop!.maxHeightCm;
                worktopheight.addEventListener("input", this.getWorktopHeight);
            }
            const credenceheight = document.getElementById("CredenceHeight") as HTMLInputElement;
            if (credenceheight) {
                credenceheight.value = "" + this.worktopController.worktop!.credenceHeightCm;
                credenceheight.addEventListener("input", this.getCredenceHeight);
            }
            
            //Set all the coating buttons listeners.
            if (this.worktopController.coatToUpdate !== null) {
                this.worktopController.coatingsData.forEach((coating: Coating, index: number) => {
                    const actualCoating = document.getElementById(`Coating-${index}`) as HTMLElement & {coating?: Coating};
                    if (!actualCoating) return;
                    actualCoating.coating = coating;
                    actualCoating.addEventListener("click", this.updateCoating)
                })
            }
        });


    }

    /*
    Exactly the same as binEvent but now destroy all current listener to avoid memory leak.
    */
    destroyEvents() {
        this.eventMappings.forEach(({id, event, handler}) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.removeEventListener(event, handler);
        });
        const worktopheight = document.getElementById("WorktopHeight");
        if (worktopheight) {
            worktopheight.removeEventListener("input", this.getWorktopHeight);
        }
    
        const credenceheight = document.getElementById("CredenceHeight");
        if (credenceheight) {
            credenceheight.removeEventListener("input", this.getCredenceHeight);
        }
        if (this.worktopController.coatingsData){
            this.worktopController.coatingsData.forEach((_coating: Coating, index: number) => {
                const actualCoating = document.getElementById(`Coating-${index}`);
                if (!actualCoating) return;
                actualCoating.removeEventListener("click", this.updateCoating)
            })
        }
        
    }

    /*
    This is the initialisation of the main html for the worktop interface.
    */
    html(): string {
        return `
            <div id="worktop-toolbar" class="worktop-toolbar" style="border:1px solid grey; background-color: white;">               
                <div id="WorkTopPanel" class="worktop-panel selected-worktop">
                    ${this.getWorktopPanel()}
                </div>

                <div class="worktop-panel common">
                    <button id="GenerateWorktop" title="GenerateWorktops">
                        <i class="fa-solid fa-rotate"></i>
                    </button>
                    <button id="RemoveAllWorktop" title="Clear all worktops">
                        <i class="fa-solid fa-trash-can"></i>
                    </button>

                    <div style="height:120px;width:1px;border:1px solid grey;">
                    </div>

                    <button id="LeaveWorktop"> Quitter</button>
                </div>
            </div>
            `;
    }

    /*
    This is a controller to check wich of the element we need to display.
    */
    getWorktopPanel(): string {

        if (this.worktopController.worktop === null) {
            return `Sélectionner un plan de travail`;
        } else {
            return `
                ${this.coatingViewManager()}
                ${this.viewOnEdge()}
                <div style="height:120px;width:1px;border:1px solid grey;">
                </div>
                <div style="display: table-cell;vertical-align:middle;padding-left:20px;padding-right:20px;"">
                    <div class="worktop-title" style="padding-bottom:5px;padding-top:5px;">
                        Hauteur plan de travail:
                    </div>
                    <input type="number" id="WorktopHeight"/>

                    <div class="worktop-title" style="padding-bottom:5px;padding-top:5px;">
                        Hauteur crédence:
                    </div>
                    <input id="CredenceHeight" type="number"/>

                </div>
                <div style="padding-right:20px;">
                    <button id="RemoveAllCredences" title="Supprimer toutes les crédences">
                        <i class="fa-solid fa-eraser"></i>
                    </button>
                </div>
            `;
        }
    }
    

    /*
    We need to update the panel in order to change the current HTML code.
    */
    updateWorktopPanel() {
        let container = document.getElementById("WorkTopPanel");
        if (!container) return;
        container.innerHTML = this.getWorktopPanel();
    }
    
    /*
    Display button if a edge is actually selected
    */
    viewOnEdge(): string {
        if (this.worktopController.edge !== null) {
            return `
                <div style="padding-left:20px;padding-right:20px;">
                    <button id="ToogleLegBut">${this.worktopController.edgeHasLeg ? 'Supprimer la': 'Ajouter une'} jambe</button>
                    <button id="ToogleCredenceBut">${this.worktopController.edgeHasCredence ? 'Supprimer la': 'Ajouter une'} credence</button>
                </div>
            `;
        } else {
            return ""
        }
    }

    /*
    This is a manager for the left side of the panel.
    Switch interface between general selected worktop interface and coatings selector interface. 
    */
    coatingViewManager():string {
        if (this.worktopController.coatToUpdate === null) {
        return `
        <div class="worktop-panel">
            <div class="worktop-title">
                Revêtement :
            </div>

            ${this.coatImage()}
            <button id="OpenCoating" class="worktop-elem">
                <i class="fa-solid fa-pencil"></i>
            </button>
        </div>

        <div class="worktop-panel">
            <div class="worktop-title">
                Credence :
            </div>

            ${this.credenceImage()}
            <button id="OpenCoatingCredence" class="worktop-elem""><i
                    class="fa-solid fa-pencil"></i>
            </button>
            <button id="OffsetLeft" class="worktop-elem" style="margin-left:16px">
                <i class="fa-solid fa-arrow-left"></i>
            </button>
            <button id="OffsetRight" class="worktop-elem">
                <i class="fa-solid fa-arrow-right"></i>
            </button>
            <button id="OffsetUp" class="worktop-elem">
                <i class="fa-solid fa-arrow-up"></i>
            </button>
            <button id="OffsetDown" class="worktop-elem">
                <i class="fa-solid fa-arrow-down"></i>
            </button>
        </div>
        `;
        } else {
            return `
            <div style="padding-left:20px;padding-right:20px;">
                <a id="LeaveUpdateCoating" title="Fermer" class="icon-Close" style="color: #737373;text-decoration: none;"></a>
            </div>

            <div class="assets-config-list">
                ${this.generateCoatList()}
            </div>
            `;
        }
    }

    /*
    Generate HTML elements for each coating present in the data list of coatings.
    */
    generateCoatList(): string {
        let htmlToSend = "";
        this.worktopController.coatingsData.forEach((coating: any, index: any) => {
            htmlToSend += `
                <div id="Coating-${index}" class="assets-config-item" title="${coating.name}">
                    <img src="${this.worktopController.baseAssetUrl}api/v1/coatings/${coating._id}/medias/previews/preview1-sm.jpg"/>
                    ${this.isCurrentCoating(coating)}
                    ${this.isAnotherCoating(coating)}
                </div>              
                `    
        });
        return htmlToSend;
    }

    /*
    Display the icon selected corresponding to the current coating selected in the select coating interface.
    */
    isCurrentCoating(coating: Coating): string {
        if (this.worktopController.isCurrentWorktopCoating(coating)){
            return `
                <div style="position:relative;top:-16px;left:-57px;height:11px;cursor:pointer;font-size:14px;color:rgb(0, 192, 0);display:inline-flex;width:0px" title="Sélection actuelle">
                        <i class="fa-solid fa-check"></i>
                </div>
            `;
        } else {
            return "";
        }
    }
    
    /*
    Display a icon on the coatings that has been selected on this worktop elements on the select coating interface.
    */
    isAnotherCoating(coating: Coating): string {
        if (this.worktopController.isCurrentWorktopOtherCoating(coating)){
            return `
                <div style="position:relative;top:-16px;left:-25px;height:11px;cursor:pointer;font-size:14px;color:rgb(0, 0, 192);display:inline-flex;width:0px" title="Autre sélection">
                    <i class="fa-solid fa-sort"></i>
                </div>
            `;
        } else {
            return "";
        }
    }

    /*
    Load the current coating image for the current credence.
    */
    credenceImage(): string {
        if (this.worktopController.worktopCredence !== null) {
            return `
                <div class="worktop-elem">
                    <img src="${this.worktopController.baseAssetUrl}api/v1/coatings/${this.worktopController.worktopCredence.coatingId}/medias/previews/preview1-sm.jpg"/>
                </div>
            `;
        } else {
            return "";
        }
    }

    /*
    Load the current coating image for the current worktop.
    */
    coatImage(): string {
        if (this.worktopController.worktopCoating !== null) {
        return `
            <div class="worktop-elem">
                <img src="${this.worktopController.baseAssetUrl}api/v1/coatings/${this.worktopController.worktopCoating.coatingId}/medias/previews/preview1-sm.jpg"/>
            </div>
        `;
        } else {
            return ``;
        }

    }
}

    